import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SETTINGS } from '../configs/common.settings';

@Injectable({
  providedIn: 'root',
})
export class ItemService {
  constructor(private http: HttpClient, private router: Router) {}

  createItem(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/item/create`, payload);
  }

  getItems(): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/item/get/all`);
  }
}
